import { render, staticRenderFns } from "./flowRatio.vue?vue&type=template&id=4be5da28&scoped=true&"
import script from "./flowRatio.vue?vue&type=script&lang=js&"
export * from "./flowRatio.vue?vue&type=script&lang=js&"
import style0 from "./flowRatio.vue?vue&type=style&index=0&id=4be5da28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5da28",
  null
  
)

export default component.exports